import React, {useState, useEffect} from "react";
import {inject, observer} from "mobx-react";
// local
import {IconPlus} from "components/icons";
import {TagSelect} from "components/selects/TagSelect";
import {color} from "constants/color.consts";
import cn from "classnames";

const PrefixIcon = ({color}) => (
  <IconPlus color={color} width="16" height="16" addClass="ml-0 hght-16 mb-0 mr-1" />
);

const ProjectProcurementSelect = inject("store")(
  observer(
    ({
      store: {buyer},
      selectedProject,
      selectedProcurement,
      onProjectChange,
      onProcurementChange,
      disabled,
      viewMode = false,
      readOnly,
      addClass,
    }) => {
      const [projects, setProjects] = useState(null);
      const [procurements, setProcurements] = useState([]);
      const [hasFetchedProcurements, setHasFetchedProcurements] = useState(false);

      const tagClass = "df-row-center fz-10 pl-1 pr-[3]";

      useEffect(() => {
        !readOnly &&
          buyer
            .getProjects(true, {page: 1, tab: "all", size: 1000})
            .then((data) => setProjects(data?.rows || []));
      }, [buyer, readOnly]);

      useEffect(() => {
        if (selectedProject && !hasFetchedProcurements && !!projects) {
          buyer.getProcurements(selectedProject.id, {sort: "name"}).then((data) => {
            setProcurements(data || []);
            setHasFetchedProcurements(true);
          });
        }
      }, [selectedProject, hasFetchedProcurements, projects, buyer]);

      // Reset procurements when project changes
      useEffect(() => {
        setProcurements([]);
        setHasFetchedProcurements(false);
      }, [selectedProject, projects]);

      return (
        <div className={cn("df-row-center", {[addClass]: !!addClass})}>
          <TagSelect
            list={projects}
            value={selectedProject}
            text={{
              emptySelect: "PROJECT",
              emptyData: "NO_PROJECTS_CREATED_YET",
              emptySearchInput: "SEARCH_PROJECTS",
              info: "SELECT_PROJECT_TOOLTIP",
            }}
            uppercase
            bold
            tagColor="purple"
            prefixIcon={{
              empty: <PrefixIcon color={color.purple} />,
            }}
            disabled={disabled}
            viewMode={viewMode}
            readOnly={readOnly}
            canClear
            onChange={onProjectChange}
            addTagClass={tagClass}
          />
          {selectedProject && (
            <TagSelect
              list={procurements}
              value={selectedProcurement}
              text={{
                emptySelect: "PROCUREMENT_ITEM",
                emptySearchInput: "SEARCH_PROCUREMENTS",
              }}
              tagColor="black"
              prefixIcon={{
                empty: <PrefixIcon color={color.black} />,
              }}
              disabled={disabled || !(procurements.length || viewMode || readOnly)}
              viewMode={viewMode}
              readOnly={readOnly}
              canClear
              onChange={onProcurementChange}
              addTagClass={tagClass}
            />
          )}
        </div>
      );
    }
  )
);

export default ProjectProcurementSelect;
